<template>
  <div>
    <date-picker
      :activeTextCarouselSlide="activeCalendarPage"
      :calendarStartDate="calendarStartDate"
      :dealerCalendar="dealerCalendar"
      :formLabel="formLabel"
      :isMobile="isMobile"
      :isOptional="isOptional"
      :labelPlaceholder="labelPlaceholder"
      :locale="locale"
      :pickerVisibility="datePickerOpen"
      :selectedDates="getSelectedDates"
      :requestMode="requestMode"
      :calendarType="calendarType"
      :theme="theme"
      :rangePicker="rangePicker"
      @changeDate="changeDate"
      @maskCalendar="maskCalendarSection"
      @unmaskCalendar="unmaskCalendarSection"
      @changeSheet="changeSheet"
      @onPickerToggle="toggleDatePicker"
      @closeMobileCalendar="closeMobileCalendar"
    />
    <calendar-period
      class="datetime-picker__period-list"
      v-if="timeOptions && timeOptions.length"
      :isMobile="isMobile"
      :timeOptions="timeOptions"
      :timeOptionsLabel="timeOptionsLabel"
      :selectedSlot="getSelectedSlot"
      :requestMode="requestMode"
      @selectedSlot="onSelectedSlot"
    />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

import { DatePicker, CalendarPeriod } from '../index';

import {
  CalendarPeriodOption,
  DateRangeMode,
  DatesAvailabilityType,
  DateWorkingMode,
} from '../../models/entities/calendar.model';

import useDatetimePicker from '../../composables/datetime-picker.composable';

export default defineComponent({
  name: 'otb-datetime-picker',
  components: {
    DatePicker,
    CalendarPeriod,
  },
  props: {
    activeTextCarouselSlide: Number,
    calendarStartDate: {
      type: Date,
      default() {
        return new Date();
      },
    },
    dealerCalendar: Object as () => DatesAvailabilityType,
    isMobile: Boolean,
    isOptional: Boolean,
    formLabel: String,
    labelPlaceholder: String,
    locale: {
      type: String,
      default: 'de-DE',
    },
    selectedDay: {
      type: Object as () => DateRangeMode,
      default() {
        return {};
      },
    },
    requestMode: Boolean,
    selectedDates: Object as () => DateRangeMode,
    selectedSlot: Object as () => CalendarPeriodOption,
    timeOptions: Array as () => CalendarPeriodOption[],
    timeOptionsLabel: String,
    calendarType: {
      type: String,
      default: 'normal',
    },
    theme: {
      type: String,
      default: '',
    },
    rangePicker: {
      type: Object as () => { enabled: boolean; workingMode: DateWorkingMode },
      default() {
        return { enabled: true, workingMode: DateWorkingMode.START };
      },
    },
  },
  setup(props, { emit }) {
    const DatetimePicker = useDatetimePicker(props, { emit });

    const closeMobileCalendar = () => {
      DatetimePicker.toggleDatePicker(false);
    };

    return {
      ...DatetimePicker,
      closeMobileCalendar,
    };
  },
});
</script>
<style src="./datetime-picker.scss" lang="scss"></style>
